function convertISOToNormalDateWithoutHour(isoDate: string): string {
  const date = new Date(isoDate);

  console.log("========================================================");
  console.log(isoDate);

  // Format the date
  const formattedDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;

  // Combine the formatted date and time
  const convertedDate = `${formattedDate}`;

  return convertedDate;
}

export default convertISOToNormalDateWithoutHour;
